import React from 'react';
import { Tabs, Dropdown } from 'antd';
import { ReloadOutlined, CloseOutlined, DownOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTabs } from './../context/TabContext';
import { confirmLeave } from '../utils/leaveGuard';

/**
 * 顶部多标签栏。与 src/context/TabContext 配合。
 */
export default function TabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { tabs, activeKey, setActiveKey, closeTab, closeOthers, closeAll, updateTabLabel } = useTabs();

  if (!tabs.length) return null;

  const menuItems = [
    { key: 'reload', icon: <ReloadOutlined />, label: '刷新当前页' },
    { key: 'closeOthers', icon: <CloseOutlined />, label: '关闭其他标签' },
    { key: 'closeAll', icon: <CloseOutlined />, label: '关闭全部标签' },
  ];

  const onMenuClick = ({ key }) => {
    const current = tabs.find(t => t.key === activeKey);
    if (key === 'reload') {
      // 通过 replace 到相同路径并触发 key 变化来强制刷新（此处简单用 navigate(0)）
      if (!confirmLeave()) return;
      navigate(0);
    } else if (key === 'closeOthers') {
      if (!confirmLeave()) return;
      closeOthers(activeKey);
      if (current) navigate(current.path);
    } else if (key === 'closeAll') {
      if (!confirmLeave()) return;
      closeAll();
      navigate('/');
    }
  };

  const onEdit = (targetKey, action) => {
    if (action === 'remove') {
      // ⭐ 2026-10-25：防重复触发（antd 重渲染时 onEdit 可能被调多次 →
      //   实测一次点 × 弹了 3 次 confirm）
      const now = Date.now();
      if (onEdit._last && now - onEdit._last < 600) return;
      onEdit._last = now;
      // 关闭当前标签（或关闭后需要跳转）时，若有未保存变更则拦截
      const willNavigate = targetKey === activeKey;
      if (willNavigate && !confirmLeave()) return;
      const nextKey = closeTab(targetKey);
      if (targetKey === activeKey) {
        if (nextKey) {
          const nextTab = tabs.find(t => t.key === nextKey);
          navigate(nextTab ? nextTab.path : '/');
        } else {
          navigate('/');
        }
      }
    }
  };

  const onChange = (key) => {
    const tab = tabs.find(t => t.key === key);
    const willNavigate = tab && tab.path !== location.pathname;
    if (willNavigate && !confirmLeave()) return;
    setActiveKey(key);
    if (willNavigate) navigate(tab.path);
  };

  const items = tabs.map(t => ({
    key: t.key,
    label: t.label,
    closable: t.closable !== false,
  }));

  return (
    <div style={{
      background: '#fff',
      borderBottom: '1px solid #f0f0f0',
      padding: '4px 16px 0',
      display: 'flex',
      alignItems: 'center',
      flex: '0 0 auto',
      position: 'relative',
      zIndex: 200,
    }}>
      <Tabs
        type="editable-card"
        hideAdd
        size="small"
        activeKey={activeKey}
        onChange={onChange}
        onEdit={onEdit}
        items={items}
        style={{ flex: 1, marginBottom: 0 }}
        tabBarStyle={{ marginBottom: 0 }}
      />
      <Dropdown menu={{ items: menuItems, onClick: onMenuClick }} trigger={['click']}>
        <a style={{ marginLeft: 8, padding: '0 8px', fontSize: 12, whiteSpace: 'nowrap' }} onClick={e => e.preventDefault()}>
          标签操作 <DownOutlined />
        </a>
      </Dropdown>
    </div>
  );
}
